"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var Pill = function (_a) {
    var config = _a.config, status = _a.status;
    var pillStatus = status === 'in_transit' ? 'transit' : status;
    return ((0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__pill__wrapper", children: (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__pill__round", style: { background: config.pill[pillStatus].backgroundColor }, children: (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__pill__text", style: { color: config.pill[pillStatus].textColor }, children: config.pill[pillStatus].text }) }) }));
};
exports.Pill = Pill;
